import React from 'react';
import IconClose from '../../assets/svg/closeIconNew.svg';
import SearchIcon from '../../assets/svg/searchIconNew.svg';

const config = {
    /**
     * TODO: Will be updated when the actual image provided by design team
     * or would be completely replaced by font-icons
     */
    svgSearchIconName: 'searchinbox',
    svgSearchIconComponent: <SearchIcon />,
    svgResetIconName: 'icon-close',
    svgResetIconComponent: <IconClose />,
    showViewAll: 2,
};

export default config;
